/* RESPONSIBLE TEAM: team-ai-insights */
// Bridge route for QA assigned-reviews React view (standalone)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorReviewsAssignedRoute extends Route {
  queryParams = {
    page: { refreshModel: false },
    perPage: { refreshModel: false },
    reviewStatus: { refreshModel: false },
  };

  analytics = {
    section: 'standalone',
    place: 'monitor.reviews.assigned',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorReviewsAssignedRoute, {
  overrideRenderTemplate: false,
});
